/* require global playback */

import NativeComponentInitializers from 'shared/native_component_initializers';
import SubscriptionBanner from 'shared/components/subscription_banner';
import ContentAccessWatcher from 'shared/content_access_watcher';
import WatchSessionLimiter from 'shared/watch_session_limiter';
import KmklabsUtil from 'shared/kmklabs_util';
import AhoyEvent from 'shared/ahoy_event';
import Topic from 'shared/topic';
import { VidioHelpers } from 'shared/vidio_helpers';
import { QRCodeSVG } from '@cheprasov/qrcode';

export default class PremiumPlayerInitializer {
  constructor(currentUser){
    this._currentUser = currentUser;
  }

  initialize(){
    this.checkContentAppPreference();
  }

  checkContentAppPreference() {
    const contentAppPreference = document.querySelector('.content-app-preference-banner.hide');


    if (contentAppPreference && !VidioHelpers.isPremiumUser()) {
      const qrCode = contentAppPreference.querySelector('.content-app-preference-banner__qr-image');

      if (qrCode) {
        this.generateQrCode(qrCode);
      }

      return contentAppPreference.classList.remove('hide');
    } else if (KmklabsUtil.videoId() && KmklabsUtil.isPremium()){
      this.preparePlayer();
    }
  }

  generateQrCode(qrCode) {
    if(qrCode) {
      const deepLinkUrl = qrCode.getAttribute('data-deep-link');
      const centerLogoUrl = qrCode.getAttribute('data-logo');

      let imageOption = null;
      if (centerLogoUrl) {
        imageOption = {
          image: {
            source: centerLogoUrl,
            width: '20%',
            height: '20%',
            x: 'center',
            y: 'center',
          }
        };
      }

      const qrSVG = new QRCodeSVG(deepLinkUrl, imageOption);
      const xmlWithQRCode = qrSVG.toString();

      qrCode.innerHTML = xmlWithQRCode;
    }
  }

  preparePlayer(){
    let playableId = KmklabsUtil.videoId();
    if (this.currentUser != null) {
      let type = document.querySelector('body').getAttribute('data-controller').includes('videos');
      type = type ? 'videos' : 'livestreamings';
      this.setPlayerStatus(playableId, type);
      return;
    }

    SubscriptionBanner.show();
    if (window.player != undefined) {
      this.setNewSource(playableId, false);
    } else {
      Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, playableId, false));
    }
  }

  setNewSource(playableId, source) {
    let playerId = `player-data-${playableId}`;
    let element = document.querySelector(`#${playerId}`);

    if(element == null){
      return;
    }

    if(source == false) {
      element.setAttribute("data-vjs-clip-hls-url", "");
      element.setAttribute("data-vjs-clip-dash-url", "");
      let loader = document.querySelector(".player-loader");
      loader.style.display = 'none';
      return;
    }

    if(typeof source == 'string'){
      element.setAttribute("data-vjs-clip-hls-url", source);
    }
    PremiumPlayerInitializer.initializePlayer(playerId);
  }

  static initializePlayer(playerId){
    window.player = new playback.Player(playerId); // jshint ignore:line
    return window.player.initialize();
  }

  setPlayerStatus(playableId, type) {
    $.ajax({
      url: `/interactions_stream.json?video_id=${playableId}&type=${type}`,
      dataType: 'json',
      method: 'GET'
    }).done(function(data) {
      this.onInteractionStreamSuccess(playableId, type, data);
    }.bind(this)).fail(function(err){
      this.onInteractionStreamFailed(parseInt(err.status), playableId, type);
    }.bind(this));
  }

  onInteractionStreamSuccess(playableId, playableType, data) {
    if (window.player == undefined) {
      Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, playableId, data.source));
    } else {
      this.setNewSource(playableId, data.source);
    }
    window.kmklabs.video.source = data.source;

    this.initComponentInitializer();
    this.toggleSubscriptionBanner(data.source);
    this.initWatchAccess(playableId, playableType, data);
  }

  typeChopping(value) {
    if (value === 'videos') return 'video';
    if (value === 'livestreamings') return 'livestreaming';
    return value;
  }

  onInteractionStreamFailed(statusCode, playableId, type) {
    if (statusCode == 403) {
      WatchSessionLimiter.showBanner();
      WatchSessionLimiter.setBackgroundBlocker();
      AhoyEvent.send('PLAYBACK::BLOCKER', {
        content_type: this.typeChopping(type),
        is_premier: KmklabsUtil.isPremium(),
        content_id: playableId,
        blocker_type: 'limitwatch',
      });
    }
  }

  initWatchAccess(playableId, playableType, data) {
    if(data.single_watch_session == true){
      WatchSessionLimiter.startHeartbeat(playableId);
    }

    if(data.periodic_content_access_check) {
      ContentAccessWatcher.watch(playableId, playableType);
    }
  }

  toggleSubscriptionBanner(source){
    if (source == null) {
      return;
    } else if (source == false) {
      // on livestreaming, it only changes the title since the banner already shown
      // on VOD, it display the banner
      SubscriptionBanner.show();
    } else {
      SubscriptionBanner.hide();
    }
  }

  initComponentInitializer() {
    new NativeComponentInitializers();
  }

  get currentUser() {
    return this.isEmpty(this._currentUser) ? null : this._currentUser;
  }

  isEmpty(obj) {
    for(var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop))
        return false;
    }
    return true;
  }
}
